import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { GoogleAnalyticsService } from 'app/services/analytics/google-analitics-service';
import { ApiForgotPasswordService } from 'app/services/api/api-forgot-password.service';


@Component({
  standalone: false,
    selector: 'fuse-dialog-forgot-password',
    templateUrl: './dialog-forgot-password.component.html',
    styleUrls: ['./dialog-forgot-password.component.scss']
})

export class DialogForgotPassword implements OnInit {

    public formGroup: UntypedFormGroup;

    constructor(
        private apiForgotPassword: ApiForgotPasswordService,
        public dialogRef: MatDialogRef<DialogForgotPassword>,
        private toast: NotificationsService,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.formGroup = new UntypedFormGroup({
            'email': new UntypedFormControl('', [Validators.required, Validators.email]),
        });
    }

    ngOnInit() {
        this.googleAnalyticsService.pageEmitter('ForgotPasswordPage');
    }

    onYesClick(): void {
        this.apiForgotPassword.apiForgotPassword(this.formGroup.get('email').value)
            .subscribe({
                next: (data) => {
                    this.googleAnalyticsService.eventEmitter('ForgotPasswordPage', 'Send Mail successfully');
                    this.toast.success('Attenzione', 'Ti abbiamo inviato una mail');
                },
                error: (err) => {
                    if (err.status === 404 && err.error.message === 'USER_OR_EMAIL_NOT_FOUND') {
                        this.googleAnalyticsService.eventEmitter('ForgotPasswordPage', 'Send Mail fault (email not found)');
                        this.toast.error('Attenzione', 'Email non presente in archivio');
                    } else {
                        this.googleAnalyticsService.eventEmitter('ForgotPasswordPage', 'Send Mail fault (generic)');
                        this.toast.error('Attenzione', 'Errore di sistema');
                    }
                }
            });
    }

    goLogin(): void {
        this.dialogRef.close({ goLogin: true });
    }

    resendMail(): void {
        this.onYesClick();
    }


}
